<template>
  <div>
    <aplayer :list="musics" :music="musics[0]" :show-lrc="true"></aplayer>
  </div>
</template>
<script>
  import aplayer from "vue-aplayer";

  export default {
    name: 'PortalAudios',
    props: {
      musics: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    data() {
      return {
        // 音频列表
        // musics: [{
        //     title: "歌曲名称",
        //     artist: "演唱者",
        //     url: "https://www.cambridgeenglish.org/images/153149-movers-sample-listening-test-vol2.mp3",
        //     pic: "封面图片URL",
        //     lrc: "歌词或歌词文件的URL",
        // }]
      };
    },

    mounted() {

    },

    methods: {},
    components: {
      aplayer
    }
  };
</script>

<style lang="less" scoped>

</style>
